const types = {
  SET_LIST: 'SET_LIST',
  SET_TEMPLATE: 'SET_TEMPLATE',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/templates/mutations-types.js